import type { SVGProps } from 'react'
const SvgSyLitecoin = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="M496.4 554.5 418.2 818h418c11.6-.4 21.4 8.7 21.8 20.3v6.9l-36.3 125.4c-3.3 12.2-14.6 20.5-27.3 20H154.7l107.2-365.3L142 661.7l27.3-83.6 119.9-36.3L440 29.3c3.4-12.1 14.7-20.4 27.3-20H629c11.6-.4 21.4 8.7 21.8 20.3v6.9L523.6 469l119.9-36.3-25.4 87.2z" />
	</svg>
)
export default SvgSyLitecoin
